import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Loading, MessagePlugin } from 'tdesign-react';
import { setCurrentHost } from '@/slices/execRecordSlice';
import { getStatusClass } from '../Steps';
import { RESULT_STATUS, getExecResultCodeStatus } from '../..';

function Servers({ servers, loading, selectHost, currentHost }) {
  const handleClick = (item, self) => {
    if (self) {
      return;
    }
    if (getExecResultCodeStatus(item.execResultCode) === RESULT_STATUS.READY) {
      MessagePlugin.info('该节点尚未执行');
      return;
    }
    selectHost(item);
  };
  return (
    <Root>
      <Title>
        执行清单 <Loading style={{ marginLeft: 4 }} loading={loading} size='small' />
      </Title>
      {servers.map((item) => (
        <Item
          className={getStatusClass(item.execResultCode)}
          $active={currentHost?.id === item.id}
          onClick={() => handleClick(item, currentHost?.id === item.id)}
          key={item.id}
        >
          {item.serviceIp || item.hostIp}
        </Item>
      ))}
    </Root>
  );
}

export default connect(
  (state) => ({
    servers: state.execRecord.servers,
    currentHost: state.execRecord.currentHost,
    loading: state.execRecord.recordHostFetching,
  }),
  {
    selectHost: setCurrentHost,
  },
)(Servers);

const Root = styled.div`
  padding: 16px 20px;
  width: 150px;
`;

const Title = styled.div`
  color: var(--td-text-color-primary);
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const Item = styled.div`
  font-size: 13px;
  position: relative;
  display: flex;
  align-items: flex-start;
  word-break: break-all;
  height: 30px;
  cursor: pointer;
  padding-left: 20px;
  color: var(--td-text-color-secondary);
  font-weight: ${(props) => (props.$active ? 'bold' : 'normal')};
  ::before {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    z-index: 1;
    left: 0;
    top: 6px;
    margin: auto;
    background-color: var(--td-text-color-secondary);
    border-radius: 100%;
  }
  &.success,
  &.error,
  &.processing {
    color: var(--td-text-color-primary);
  }
  &.success::before {
    background-color: var(--td-success-color);
  }
  &.error::before {
    background-color: var(--td-error-color);
  }
  &.processing::before {
    background-color: var(--td-brand-color);
  }
`;
